import {delay} from 'redux-saga';
import {takeEvery, all, put, call} from 'redux-saga/effects';

import {COMPOSE_ACTIONS, DELAYED_ACTION} from './';

function* composeActionsWorker(action) {
  const {extraActions} = action.payload;
  yield* extraActions.map(a => put(a())); // TODO: in future send the output from the prev action to the next
}

function* delayedActionWorker(action) {
  yield call(delay, action.payload.delay);
  yield put(action.payload.action()); // Use composeActions if you need more than one action
}

function* commonSaga() {
  yield all([
    takeEvery(COMPOSE_ACTIONS, composeActionsWorker),
    takeEvery(DELAYED_ACTION, delayedActionWorker)
  ]);
}

export default commonSaga;
